/* Verktygsplatsen — app-free wishlist ("Spara"). Stores saved products in localStorage
   and auto-wires save buttons ([data-vp-save]), count badges ([data-vp-saved-count])
   and the wishlist grid ([data-vp-wishlist]). No account/app required (per-browser). */
(function () {
  var KEY = 'vp_saved_v1';

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('vp:wishlist:change', { detail: { count: a.length } }));
  }
  function has(handle) { return read().some(function (p) { return p.handle === handle; }); }
  function toggle(p) {
    var a = read(), i = -1;
    for (var k = 0; k < a.length; k++) { if (a[k].handle === p.handle) { i = k; break; } }
    if (i > -1) { a.splice(i, 1); } else { a.unshift(p); }
    write(a);
    return i === -1; // true if now saved
  }
  function remove(handle) { write(read().filter(function (p) { return p.handle !== handle; })); }

  window.VPWishlist = { read: read, has: has, toggle: toggle, remove: remove, count: function () { return read().length; } };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function dataFromBtn(b) {
    return {
      handle: b.getAttribute('data-handle'),
      title: b.getAttribute('data-title'),
      url: b.getAttribute('data-url'),
      image: b.getAttribute('data-image'),
      price: b.getAttribute('data-price'),
      vendor: b.getAttribute('data-vendor')
    };
  }
  function reflect(b) {
    var on = has(b.getAttribute('data-handle'));
    b.classList.toggle('is-saved', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var l = b.querySelector('.lbl');
    if (l) { l.textContent = on ? 'Sparad' : 'Spara'; }
  }
  function reflectAll() { document.querySelectorAll('[data-vp-save]').forEach(reflect); }
  function counts() {
    var c = read().length;
    document.querySelectorAll('[data-vp-saved-count]').forEach(function (el) {
      el.textContent = c;
      el.hidden = c === 0;
    });
  }
  function renderGrids() {
    document.querySelectorAll('[data-vp-wishlist]').forEach(function (grid) {
      var items = read();
      var root = grid.closest('[data-vp-wishlist-root]') || document;
      var empty = root.querySelector('[data-vp-wishlist-empty]');
      if (empty) { empty.hidden = items.length > 0; }
      grid.hidden = items.length === 0;
      grid.innerHTML = items.map(function (p) {
        return '<article class="vpw-card">'
          + '<button class="vpw-remove" data-vp-remove="' + esc(p.handle) + '" aria-label="Ta bort">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
          + '</button>'
          + '<a class="vpw-img" href="' + esc(p.url || '#') + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>'
          + '<div class="vpw-bd">'
          + (p.vendor ? '<span class="vpw-br">' + esc(p.vendor) + '</span>' : '')
          + '<a class="vpw-nm" href="' + esc(p.url || '#') + '">' + esc(p.title || '') + '</a>'
          + (p.price ? '<span class="vpw-pr">' + esc(p.price) + '</span>' : '')
          + '</div>'
          + '<a class="vpw-view" href="' + esc(p.url || '#') + '">Visa produkt</a>'
          + '</article>';
      }).join('');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vp-save]');
    if (b) { e.preventDefault(); toggle(dataFromBtn(b)); reflect(b); return; }
    var r = e.target.closest('[data-vp-remove]');
    if (r) { e.preventDefault(); remove(r.getAttribute('data-vp-remove')); }
  });
  document.addEventListener('vp:wishlist:change', function () { reflectAll(); counts(); renderGrids(); });

  function init() { reflectAll(); counts(); renderGrids(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
